import React from 'react';
import styled from 'styled-components';
import { Typography } from '@fupa/fupa-uikit';
const StyledPlayerName = styled.div.withConfig({
  componentId: "sc-7e999m-0"
})(["flex-direction:column;display:flex;flex:1;height:3.25rem;line-height:1.3;"]);
const SCTypography = styled(Typography).withConfig({
  componentId: "sc-7e999m-1"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
export const PlayerName = _ref => {
  let {
    firstName,
    lastName
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledPlayerName, {
    "data-sentry-element": "StyledPlayerName",
    "data-sentry-component": "PlayerName",
    "data-sentry-source-file": "PlayerName.tsx"
  }, /*#__PURE__*/React.createElement(SCTypography, {
    variant: 'subheading2',
    component: 'span',
    "data-sentry-element": "SCTypography",
    "data-sentry-source-file": "PlayerName.tsx"
  }, firstName), /*#__PURE__*/React.createElement(SCTypography, {
    variant: 'headline2',
    component: 'span',
    "data-sentry-element": "SCTypography",
    "data-sentry-source-file": "PlayerName.tsx"
  }, lastName));
};